<template>
  <div class="container-info">
    <div class="header-shadow"></div>

    <div class="titleClassF">
      <span>
        {{ $t('userAccount.personalAddresses') }}
      </span>
    </div>
    <h4>{{ $t('forms.billingAddress') }}</h4>

    <div class="profil-infos">
      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.address') }}</span>
        </div>
        <vv-form-text-input-profil
          label="address"
          id="billing-address"
          v-model="billingAddress"
          :validate="'required'"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.complement') }}</span>
        </div>
        <vv-form-text-input-profil
          label="billingComplement"
          id="billing-complement"
          v-model="billingComplement"
          :validate="''"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.billingPostalCode') }}</span>
        </div>
        <vv-form-text-input-profil
          label="billingPostalCode"
          id="billing-postal-code"
          v-model="billingPostalCode"
          :validate="'required|numeric'"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.billingCity') }}</span>
        </div>
        <vv-form-text-input-profil
          label="billingCity"
          id="billing-city"
          v-model="billingCity"
          :validate="'required'"
        />
      </div>

      <div class="content">
        <div class="text-element">
          <span>{{ $t('forms.billingCountry') }}</span>
        </div>
        <vv-form-text-input-profil
          label="billingCountry"
          id="billing-country"
          v-model="billingCountry"
          :validate="'required'"
        />
      </div>
    </div>
    <vv-form-checkbox-input
      class="checkBox"
      label="shippingForBilling"
      id="billing-for-shipping"
      v-model="billingForShipping"
    />

    <div v-if="!billingForShipping">
      <h4>{{ $t('forms.shippingAddress') }}</h4>

      <div class="profil-infos">
        <div class="content">
          <div class="text-element">
            <span>{{ $t('forms.address') }}</span>
          </div>
          <vv-form-text-input-profil
            label="address"
            id="address"
            v-model="shippingAddress"
            :validate="'required'"
          />
        </div>

        <div class="content">
          <div class="text-element">
            <span>{{ $t('forms.complement') }}</span>
          </div>
          <vv-form-text-input-profil
            label="billingComplement"
            id="billing-complement"
            v-model="shippingComplement"
            :validate="''"
          />
        </div>

        <div class="content">
          <div class="text-element">
            <span>{{ $t('forms.billingPostalCode') }}</span>
          </div>
          <vv-form-text-input-profil
            label="billingPostalCode"
            id="billing-postal-code"
            v-model="shippingPostalCode"
            :validate="'required|numeric'"
          />
        </div>
        <div class="content">
          <div class="text-element">
            <span>{{ $t('forms.billingCity') }}</span>
          </div>
          <vv-form-text-input-profil
            label="billingCity"
            id="billing-city"
            v-model="shippingCity"
            :validate="'required'"
          />
        </div>
        <div class="content bottom">
          <div class="text-element">
            <span>{{ $t('forms.billingCountry') }}</span>
          </div>
          <vv-form-text-input-profil
            label="billingCountry"
            id="billing-country"
            v-model="shippingCountry"
            :validate="'required'"
          />
        </div>
      </div>
    </div>
    <br v-if="error || success" />
    <p class="message" v-if="error">{{ $t(errorMessage) }}</p>
    <p class="message" v-if="success">{{ $t('forms.updatedWithSuccess') }}</p>

    <div class="endPage">
      <div class="password-button back">
        <span class="change-password-cta" @click="goProfil">{{ $t('userAccount.goProfil') }}</span>
      </div>
      <div class="password-button">
        <span class="change-password-cta validate" @click="updateAddress">
          {{ $t('forms.validate') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VvFormTextInputProfil from './VvFormTextInputProfil.vue'
import VvFormCheckboxInput from '@/components/common/forms/VvFormCheckboxInput'
import userMixin from '@/mixins/user'

export default {
  name: 'UserAccountAddresses',
  mixins: [userMixin],
  components: {
    VvFormCheckboxInput,
    VvFormTextInputProfil
  },
  data: () => ({
    shippingAddress: '',
    shippingComplement: '',
    shippingPostalCode: '',
    shippingCity: '',
    shippingCountry: '',
    billingAddress: '',
    billingComplement: '',
    billingPostalCode: '',
    billingCity: '',
    billingCountry: '',
    billingForShipping: true,
    isLoading: false,
    error: false,
    errorMessage: '',
    success: false
  }),
  methods: {
    saveAndGoProfil() {
      this.success = false
      this.$router.push({ name: 'userAccountPersonnalInformation' })
    },
    async updateAddress() {
      this.error = false
      this.errorMessage = 'forms.updatedWithError'
      this.success = false

      const validFields = await Promise.all(
        this.$children.map(child => child.$validator.validateAll())
      )
      if (validFields.some(verification => verification === false)) {
        return
      }

      const updatePayload = {
        billingAddress: this.billingAddress,
        billingComplement: this.billingComplement,
        billingPostalCode: this.billingPostalCode,
        billingCity: this.billingCity,
        billingCountry: this.billingCountry
      }

      if (!this.billingForShipping) {
        updatePayload['shippingAddress'] = this.shippingAddress
        updatePayload['shippingComplement'] = this.shippingComplement
        updatePayload['shippingPostalCode'] = this.shippingPostalCode
        updatePayload['shippingCity'] = this.shippingCity
        updatePayload['shippingCountry'] = this.shippingCountry
      } else {
        updatePayload['shippingAddress'] = this.billingAddress
        updatePayload['shippingComplement'] = this.billingComplement
        updatePayload['shippingPostalCode'] = this.billingPostalCode
        updatePayload['shippingCity'] = this.billingCity
        updatePayload['shippingCountry'] = this.billingCountry
      }

      updatePayload['billingForShipping'] = this.billingForShipping

      try {
        await this.updateUserInformations(updatePayload)

        this.success = true
        setTimeout(() => this.saveAndGoProfil(), 2000)
      } catch (error) {
        this.error = true
        if (error.code) {
          this.errorMessage = error.code
        }

        setTimeout(() => (this.error = false), 2000)
      }
    },
    goProfil() {
      this.$router.push({
        name: 'userAccountPersonnalInformation'
      })
    }
  },
  mounted() {
    if (this.user) {
      this.billingAddress = this.user.billingAddress || ''
      this.billingComplement = this.user.billingComplement || ''
      this.billingPostalCode = this.user.billingPostalCode || ''
      this.billingCity = this.user.billingCity || ''
      this.billingCountry = this.user.billingCountry || ''

      this.shippingAddress = this.user.shippingAddress || ''
      this.shippingComplement = this.user.shippingComplement || ''
      this.shippingPostalCode = this.user.shippingPostalCode || ''
      this.shippingCity = this.user.shippingCity || ''
      this.shippingCountry = this.user.shippingCountry || ''

      this.billingForShipping = this.user.billingForShipping || true
    }
  },
  provide() {
    return { $validator: this.$validator }
  }
}
</script>

<style scoped lang="scss">
.header-shadow {
  display: flex;
  background-image: url('../../../../src/assets/account-background.jpg');
  width: 100%;
  height: 325px;
}

.container-info {
  @media screen and (max-width: 400px) {
    //mobile version
    width: 100%;
    margin: 17px 17px 23px 0px;
  }
}

.profil-infos {
  display: flex;
  gap: 10px;
  gap: 10px 20px;
  row-gap: 10px;
  column-gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}
.titleClassF {
  display: flex;
  justify-content: flex-end;
  text-transform: uppercase;
  font: normal normal bold 25px Helvetica;
  color: #404040;
  letter-spacing: 0px;
  color: #404040;
  border: #404040 solid 2px;
  margin-left: -35px;
  width: 60%;
  padding: 10px;
  align-items: center;
  margin-bottom: 50px;
  margin-top: 30px;
}
.content {
  width: 40%;
  min-width: 300px;
}

.text-element {
  font-size: 25px;
  font-weight: bold;
  padding: 10px;

  font-family: 'DM Sans', sans-serif;
  font-style: italic;
  letter-spacing: 0px;
  color: #404040;
  opacity: 1;

  & span {
    font-size: 30px;
  }
}
.multi-col {
  display: flex;
  flex-direction: row;
}

h4 {
  height: 2rem;
  padding-top: 5px;
  text-align: center;
  font-size: 1.5rem;
  background-color: #404040;
  color: #ffffff;
  font-family: 'DM Sans', sans-serif;
}
.checkBox {
  margin-left: 10%;
  margin-top: 20px;
  width: 275px;
}
.validate-button {
  width: 200px;
  margin-left: 42%;
  margin-bottom: 20px;
}

.bottom {
  margin-bottom: 20px;
}

.message {
  background-color: #404040;
  color: #ffffff;
  width: 30%;
  height: 1.3rem;
  margin: 10px auto;
  text-align: center;
  border-radius: 10px;
  padding-top: 3px;
}

.endPage {
  display: flex;
  align-items: center;
  width: 550px;
  margin: auto;
  margin-top: 40px;
  padding-bottom: 30px;
  margin-left: 35%;
  font-family: normal normal normal 38px/53px DM Sans;
}
.password-button {
  width: 500px;
  margin: 10px;
  margin-left: 30px;
}

.change-password-cta {
  float: left;
  border-radius: 25px;
  background: #404040;
  margin-top: -30px;
  cursor: pointer;
  color: white;
  padding: 10px 15px;
}
.validate {
  background: #a3a2a2;
}

@media (max-width: 1024px) {
  .container-info {
    padding-bottom: 60px;
  }
  .endPage {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 50px;
    margin-top: 40px;
    font-family: normal normal normal 38px/53px DM Sans;
  }
  .header-shadow {
    display: none;
  }
  .validate-button {
    margin-top: 30px;
  }

  .back {
    display: none;
  }
  .password-button {
    margin-left: 60px;
  }
}
@media (max-width: 620px) {
  .container-info {
    padding-bottom: 50px;
  }
  .titleClassF {
    margin-top: 100px;
    margin-left: -5px;
  }

  .validate-button {
    width: 200px;
    margin-left: 25%;
    margin-top: 10px;
    margin-bottom: 0px;
  }
  .message {
    margin-top: 20px;
    width: 50%;
  }
  .checkBox {
    margin-left: 10%;
  }
  .endPage {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 50px;
    margin-top: 40px;
    font-family: normal normal normal 38px/53px DM Sans;
  }
  .password-button {
    margin-left: -30px;
    width: 230px;
  }
  .back {
    display: none;
  }
}
</style>
